import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { OutageModel } from '../../models/outage.model';

@Component({
  selector: 'jsg-planned-outage-toolbar',
  templateUrl: './planned-outage-toolbar.component.html',
  styleUrls: ['./planned-outage-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlannedOutageToolbarComponent {
  @Input() outage: OutageModel;
  @Output() readonly dismiss = new EventEmitter();
  @Output() readonly viewReleaseNotes = new EventEmitter();
}
